module.exports = __webpack_public_path__ + "static/media/ktm-08.ce526750.jpg";